import type {EagColumnOrGroup} from '../../../../../types/EagColumnGroup';
import {isEagColumnGroup} from '../../../../../utils/isEagColumnGroup';

export type ColumnGroupMeta = {
  groupId: string;
  label: string;
  /** Availability-type groups get the teal pill treatment; everything else is neutral. */
  isAvailability: boolean;
};

/**
 * Maps every grouped leaf column key to its group's display metadata
 * (header name + availability flag) used by the columns panel pills and
 * the hidden-section sub-headers. Ungrouped columns are absent from the map.
 */
export const buildColumnGroupMeta = (
  columnConfig: EagColumnOrGroup[] | undefined
): Map<string, ColumnGroupMeta> => {
  const map = new Map<string, ColumnGroupMeta>();

  for (const item of columnConfig ?? []) {
    if (!isEagColumnGroup(item)) {
      continue;
    }
    const meta: ColumnGroupMeta = {
      groupId: item.groupId,
      label: item.headerName,
      isAvailability: item.groupId.toLowerCase().includes('availability'),
    };
    for (const child of item.children) {
      map.set(child.key, meta);
    }
  }

  return map;
};
